import { CentralErrorHandlingProvider } from '@experiences/error';
import { isLocalFeatureFlagsEnabled } from '@experiences/feature-flags';
import { useUpdateLocalizationRoute } from '@experiences/locales';
import {
    ServiceOrderProvider,
    SnackbarProvider,
    UiDialogProvider,
    UiErrorBoundary,
    UiSuspensefulOutlet,
} from '@experiences/ui-common';
import React from 'react';

import { PortalAuthenticationProvider } from '../auth/PortalAuthenticationProvider';
import { useTabName } from '../component/common/useTabName';
import { FeatureFlagOverrideDrawer } from '../component/diagnostics/FeatureFlagOverrideDrawer';

const App = () => {
    useTabName();
    useUpdateLocalizationRoute();

    return (
        <CentralErrorHandlingProvider>
            <SnackbarProvider>
                <PortalAuthenticationProvider>
                    <UiDialogProvider>
                        <ServiceOrderProvider>
                            <UiErrorBoundary>
                                <UiSuspensefulOutlet />
                                {isLocalFeatureFlagsEnabled && <FeatureFlagOverrideDrawer />}
                            </UiErrorBoundary>
                        </ServiceOrderProvider>
                    </UiDialogProvider>
                </PortalAuthenticationProvider>
            </SnackbarProvider>
        </CentralErrorHandlingProvider>
    );
};
export default App;
